module.exports = __webpack_public_path__ + "img/pearson_help.fbeae99f.png";